module.exports = __webpack_public_path__ + "img/Suv_Side_Right.0b8b2f09.svg";